import { ArrowLeft, ArrowRight, LockKeyhole, ShieldCheck } from "lucide-react";
import { useState } from "react";
import { Mark } from "../../../components/public-site";

export function ProductionSignIn() {
  const office = new URLSearchParams(window.location.search).has("office");
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  return (
    <div className="dc-login">
      <div className="dc-login-main">
        <Mark />
        <div>
          <p className="dc-eyebrow">{office ? "PLATFORM ADMINISTRATION" : "YOUR PERSONAL CHAMBER"}</p>
          <h1>{office ? "An orderly platform." : "Welcome to"}<br /><em>{office ? "A considered office." : "your chamber."}</em></h1>
          <p>{office ? "A separate place to manage chambers and operational health." : "Your matters, your documents, your next clear step. Right where you left them."}</p>
          {new URLSearchParams(window.location.search).has("access") && <p className="dc-form-error" role="alert">This identity is not assigned to that workspace. Platform administrators use the Administration Office; Mahesh enters with his own chamber login ID and password.</p>}
          {office && <div className="dc-login-box">
            <div className="dc-login-icon">
              {office ? <ShieldCheck /> : <LockKeyhole />}
              <span>{office ? "Administration access" : "Secure advocate access"}<small>Password, recovery and authenticator MFA</small></span>
            </div>
            <p className="dc-note">Only the invited platform administrator can enter the Administration Office with password and authenticator MFA.</p>
            <a className="dc-action" href="/api/auth/start?office=1">Continue securely <ArrowRight size={16} /></a>
          </div>}
          {!office && <div className="dc-login-box dc-pilot-login">
            <div className="dc-login-icon"><LockKeyhole /><span>Founding pilot access<small>Temporary credentials issued by the Administration Office</small></span></div>
            <form onSubmit={async e => {
              e.preventDefault(); setBusy(true); setError("");
              const form = new FormData(e.currentTarget);
              try {
                const result = await fetch("/api/access/login", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ login_id: form.get("login_id"), password: form.get("password") }) });
                const data = await result.json() as { error?: string; redirect?: string };
                if (!result.ok) throw Error(data.error || "Unable to sign in.");
                window.location.assign(data.redirect || "/chamber");
              } catch (e) { setError(e instanceof Error ? e.message : "Unable to sign in."); }
              finally { setBusy(false); }
            }}>
              <label>Login ID<input name="login_id" autoComplete="username" required minLength={3} maxLength={64} /></label>
              <label>Temporary password<input name="password" type="password" autoComplete="current-password" required minLength={12} maxLength={128} /></label>
              {error && <p className="dc-form-error" role="alert">{error}</p>}
              <button className="dc-action" disabled={busy}>{busy ? "Opening chamber…" : "Enter pilot chamber"}<ArrowRight size={16} /></button>
            </form>
            <p className="dc-note">Mahesh uses his own chamber credentials. Administrator sign-in does not grant access to client matters. Temporary access expires automatically and can be suspended or reissued by an authenticated administrator.</p>
          </div>}
          {!office && <div className="dc-login-box">
            <div className="dc-login-icon"><ShieldCheck /><span>Permanent advocate sign-in<small>Email, password recovery and authenticator MFA</small></span></div>
            <p className="dc-note">After claiming the chamber from inside the temporary session, continue here with the invitation sent to the verified email address.</p>
            <a className="dc-action" href="/api/auth/start">Continue secure sign-in <ArrowRight size={16} /></a>
          </div>}
          <a className="dc-text-link" href={office ? "/sign-in" : "/sign-in?office=1"}>{office ? "Return to advocate sign in" : "Platform administrator?"}<ArrowRight size={14} /></a>
        </div>
        <a className="dc-text-link" href="/"><ArrowLeft size={14} />Back to Digital Chambers</a>
      </div>
      <div className="dc-login-art">
        <img src="/chamber-hero.png" alt="A calm advocate’s desk" />
        <div><small>THE FOUNDING EDITION</small><h2>Space for your<br /><em>finest work.</em></h2><p>Digital Chambers · A MindForgeAI product</p></div>
      </div>
    </div>
  );
}
